import * as variable from '../../../../../utils/Variable'

import { ErrorDetails, LocationState } from '../types/IHttpStatusError'

export const getErrorDetails = (statusCode: number, state?: LocationState | null): ErrorDetails => {
  const fallback = {
    alertLevel: state?.alertLevel || 'error',
    title: state?.title || 'Oops!',
    heading: state?.message || 'An unexpected error occurred, please try again.',
  }

  const errorDetailsMap: Record<number, ErrorDetails> = {
    [variable.httpStatusCodes.badRequest]: {
      alertLevel: fallback.alertLevel,
      title: state?.title || 'Oops! Bad Request',
      heading: state?.message || 'There is something wrong with your request.',
    },
    [variable.httpStatusCodes.unauthorized]: {
      alertLevel: fallback.alertLevel,
      title: state?.title || 'Oops! Unauthorized',
      heading: state?.message || 'You are not authenticated, please login.',
    },
    [variable.httpStatusCodes.paymentRequired]: {
      alertLevel: fallback.alertLevel,
      title: state?.title || 'Oops! Payment Required',
      heading: state?.message || 'Content not available until payment is completed.',
    },
    [variable.httpStatusCodes.forbidden]: {
      alertLevel: fallback.alertLevel,
      title: state?.title || 'Oops! Forbidden',
      heading: state?.message || 'You do not have permission to access this resource.',
    },
    [variable.httpStatusCodes.notFound]: {
      alertLevel: fallback.alertLevel,
      title: state?.title || 'Oops! Page Not Found',
      heading: state?.message || "Wandered a bit far, have we? Let's find another way around.",
    },
    [variable.httpStatusCodes.conflict]: {
      alertLevel: fallback.alertLevel,
      title: state?.title || 'Oops! Conflict Detected',
      heading: state?.message || 'There is a conflict with the request.',
    },
    [variable.httpStatusCodes.unprocessableEntity]: {
      alertLevel: fallback.alertLevel,
      title: state?.title || 'Oops! Unprocessable Entity',
      heading: state?.message || 'Unable to process the request.',
    },
    [variable.httpStatusCodes.tooManyRequests]: {
      alertLevel: fallback.alertLevel,
      title: state?.title || 'Oops! Too Many Requests',
      heading: state?.message || 'Too many requests, please retry later.',
    },
    [variable.httpStatusCodes.internalServerError]: {
      alertLevel: fallback.alertLevel,
      title: state?.title || 'Oops! Internal Server Error',
      heading: state?.message || 'Encountered an unexpected error.',
    },
    [variable.httpStatusCodes.serviceUnavailable]: {
      alertLevel: fallback.alertLevel,
      title: state?.title || 'Oops! Service Unavailable',
      heading: state?.message || 'The server is unavailable at the moment, please try later.',
    },
  }

  return errorDetailsMap[statusCode] || fallback
}
